import { Component, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import moment from 'moment';
import { HikiateStatusService } from './hikiate-status.service';
import { HikiateStatusViewDialogComponent } from '../hikiate-status-view-dialog/hikiate-status-view-dialog.component';
import { HikiateStatusAddDialogComponent } from '../hikiate-status-add-dialog/hikiate-status-add-dialog.component';
import { ColumnMode, SelectionType } from '@swimlane/ngx-datatable';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ExportToExcelService } from '../common/export-to-excel.service';
import { DialogData } from '../dialog-data/dialog-data';
import { NgxSpinnerService } from "ngx-spinner";
import { GlobalService } from '../global.service';


@Component({
    selector: 'app-hikiate-status',
    templateUrl: './hikiate-status.component.html',
    styleUrls: ['./hikiate-status.component.css'],
    standalone: false
})
export class HikiateStatusComponent implements OnInit {

  //Date transform
  pipe = new DatePipe('en-US');
  currentDate = moment().format('DD/MM/YYYY');

  //export
  fileName = "HikiateStatus";
  exportData = [];
  sheetName = [];

  //alertMessage
  errorMessage: string = '';
  successMessage: string = '';

  //ngModel values for search
  step = 0;
  namc: any = "";
  family: any = "";
  hikiateStatus: any = "";
  effectiveInDate: any = "";
  effectiveOutDate: any = "";
  hikiateStatusDescription: any = "";
  dataLoadTS: any = "";
  spinnerMessage = "Please Wait...";

  //list
  namcLst: string[] = [];
  familyLst: string[] = [];
  hikiateStatusLst: string[] = [];
  effectiveInDateLst: string[] = [];
  effectiveOutDateLst: string[] = [];

  //mat-dialog
  data: any = {};
  roleAccess: any = []
  Roledata: any = [];

  //ngx-datatable
  rows = [];
  SelectionType = SelectionType;
  selected = [];
  isLoading: boolean = false;//loadingIndicator = false;
  reorderable = true;
  @ViewChild('myTable') table;
  limitSelected: any = 50;
  showdata: boolean = true;
  columns = [

    { name: 'namc', prop: 'namc_cd' }, { name: 'family', prop: 'fam_cd' },
    { name: 'hikiateStatus', prop: 'hikiate_stat_cd' }, { name: 'hikiateStatusDescription', prop: 'hikiate_stat_desc' },
    { name: 'effectiveInDate', prop: 'eff_dt' }, { name: 'effectiveOutDate', prop: 'expr_dt' },
    { name: 'dataLoadTS', prop: 'data_load_ts' }

  ];
  ColumnMode = ColumnMode;
  recordcount: any = 0;
  sameLengthRows: boolean = false;
  accessEnable: boolean;




  constructor(private hikiateStatusService: HikiateStatusService, public dialog: MatDialog, private dialogData: DialogData,
    private exportService: ExportToExcelService, private SpinnerService: NgxSpinnerService,
    public globalrole: GlobalService,) { }

  ngOnInit(): void {
    (async () => {
      this.SpinnerService.show();
      let a = await this.userroleAccessfn();
      if (a) {
        console.log('a', a)
        //grid
        this.getGridData("initial");
      }
      this.onloadfn();
    })();
  }

  onloadfn(){
    //to get NAMC
    this.hikiateStatusService.getNamcHs().subscribe(data => {
      console.log(data);
      this.namcLst = data.payload;
    });


    // to get Family

    this.familyonload();

    // to get Hikiate Status
    this.hikiateStatusService.getHikiateStatusHs().subscribe(data => {
      console.log(data);
      this.hikiateStatusLst = data.payload;
    });

    // to get Hikiate Status Description
    // this.hikiateStatusService.getHikiateStatusDescription().subscribe(data => {
    //   console.log(data);
    // });

    // // to get EffectiveInDate
    // this.hikiateStatusService.getEffectiveInDate().subscribe(data => {
    //   console.log(data);
    // });

    // // to get EffectiveOutDate
    // this.hikiateStatusService.getEffectiveOutDate().subscribe(data => {
    //   console.log(data);
    // });

    // // to get Data Load TS
    // this.hikiateStatusService.getDataLoadTS().subscribe(data => {
    //   console.log(data);
    // });

  }

  familyonload() {
    this.hikiateStatusService.getFamily().subscribe(data => {
      console.log(data);
      this.familyLst = data.payload;
    });
  }

  //step for expansion panel
  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
  }

  //ngx-table
  onSelect({ selected }) {
    this.selected = selected;
    if (this.selected.length == selected.length) {
      this.sameLengthRows = true
    }
    if (this.selected.length == 0) {
      this.sameLengthRows = false
    }
    console.log('Select Event', selected, this.selected);

    // this.selected.splice(0, this.selected.length);
    // this.selected.push(...selected);
  }

  onActivate(event) {
    // console.log('Activate Event', event);
  }
  displayCheck(row) {
    return row.name !== 'Ethel Price';
  }

  openAddDialog(): void {
    this.successMessage = '';
    this.errorMessage = '';
    console.log(this.roleAccess.includes('Create'))
    if (this.roleAccess.includes('Create')) {
      const dialogRef = this.dialog.open(HikiateStatusAddDialogComponent, { disableClose: true });

      dialogRef.afterClosed().subscribe(result => {
        console.log('The dialog was closed', result.data);

        if (result == 'success') {
           this.getGridData("add");
          this.successMessage = "Records Added Successfully"
          // this.getGridData();
          this.globalrole.goToTop();
          this.selected = []
        }
        else if (result == 'AlreadyExists') {
          this.errorMessage = 'Data Entered already Exists!'
          this.globalrole.goToTop();
        }
        else {
          // this.errorMessage = 'Data not inserted/Valid'
        }
      });
    } else {
      this.errorMessage = "User does not have permission to perform 'create' operation";
      this.globalrole.goToTop();
    }
  }

  openViewDialog() {
    this.errorMessage = '';
    console.log(this.roleAccess.includes('Read'))
    if (this.roleAccess.includes('Read')) {
      if (this.selected.length == 1) {
        this.sendToDialog(this.selected)
        const dialogRef = this.dialog.open(HikiateStatusViewDialogComponent, {
          disableClose: true,
          data: this.dialogData
        });

        dialogRef.afterClosed().subscribe(result => {
          console.log('The dialog was closed');
          this.selected = [];
        });
      }
      else {
        if (this.sameLengthRows == true) {
          this.errorMessage = "please select a row to view"
          this.globalrole.goToTop();
        }
        if (this.sameLengthRows == false) {
          this.errorMessage = "please select a row to view"
          this.globalrole.goToTop();
        }
      }
    }
    else {
      this.errorMessage = "User does not have permission to perform 'read' operation";
      this.globalrole.goToTop();
    }
  }
  //onchange
  getfamilybynamc() {
    if (this.namc == undefined) {
      this.namc = ""
    }
    this.hikiateStatusService.getFamilyHs(this.namc).subscribe(data => {
      console.log(data);
      this.familyLst = data.payload;
      this.family = "";

    });

  }

  closeAlert(): void {
    this.errorMessage = '';
    this.successMessage = '';
  }

  sendToDialog(selected): void {

    selected.forEach(row => {
      this.dialogData.namc = row.namc_cd;
      this.dialogData.family = row.fam_cd;
      this.dialogData.hikiateStatus = row.hikiate_stat_cd;
      this.dialogData.hikiateStatusDescription = row.hikiate_stat_desc;
      this.dialogData.effectiveInDate = row.eff_dt;
      this.dialogData.effectiveOutDate = row.expr_dt;
      this.dialogData.dataLoadTS = row.data_load_ts;
    });

  }

  exportFile(): void {

    this.rows.forEach(row => {
      let obj = {
        "namc": row.namc_cd,
        "family": row.fam_cd,
        "Hikiate Status": row.hikiate_stat_cd,
        "Hikiate Status Description": row.hikiate_stat_desc,
        "Effective In Date": row.eff_dt,
        "Effective Out Date": row.expr_dt,
        "Data Load TS": row.data_load_ts,
      }
      this.exportData.push(obj);
    });

    this.exportService.exportAsExcelFile(this.exportData, this.fileName, this.sheetName);
    this.exportData = []
  }

  resetAll(data): void {
    this.selected=[]
    this.namc = '';
    this.family = '';
    this.hikiateStatus = '';
    this.effectiveInDate = '';
    this.effectiveOutDate = '';
    this.errorMessage = "";
    this.successMessage = '';
    this.familyonload();
    // this.getGridData(data);
    this.onloadfn();
  }

  search() {

    if (this.effectiveInDate && this.effectiveOutDate && this.pipe.transform(this.effectiveInDate, 'yyyy-MM-dd') > this.pipe.transform(this.effectiveOutDate, 'yyyy-MM-dd')) {

      this.errorMessage = "Effective Out Date should be greater than or equal to Effective In Date";
      this.globalrole.goToTop();
    }
    else {
      this.errorMessage = '';
      this.successMessage = '';
      this.getGridData("initial");
    }
  }

  getGridData(data) {
    this.selected=[]
    console.log(this.roleAccess.includes('Read'));
    if (this.roleAccess.includes('Read')) {
      if (this.namc == undefined) {
        this.namc = ""
      }
      if (this.family == undefined) {
        this.family = ""
      }
      if (this.hikiateStatus == undefined) {
        this.hikiateStatus = ""
      }

      let indateFormat = ''; let outdateFormat = '';
      if (this.effectiveInDate != "") {
        let d1 = moment(this.effectiveInDate).format('YYYY-MM-DD')
        let b = d1.split('T')[0]
        let parts = []
        parts = b.split('-');
        let date = new Date(parts[0], parts[1] - 1, parts[2]);
        indateFormat = moment(date).format('YYYY-MM-DD')
        this.effectiveInDate = date
      }
      if (this.effectiveOutDate != "") {
        let d1 = moment(this.effectiveOutDate).format('YYYY-MM-DD')
        let b = d1.split('T')[0]
        let parts = []
        parts = b.split('-');
        let date = new Date(parts[0], parts[1] - 1, parts[2]);
        outdateFormat = moment(date).format('YYYY-MM-DD')
        this.effectiveOutDate = date
      }
      let gridData 
      if(data=="initial"){
      gridData =
      {
        namc: this.namc,
        family: this.family,
        hikiateStatus: this.hikiateStatus,
        hikiateStatusDescription: this.hikiateStatusDescription,
        effectiveInDate: indateFormat,
        effectiveOutDate: outdateFormat,
        dataLoadTS: this.dataLoadTS,
        option: data
      }
    }else{
      gridData =
      {
        namc: "",
        family:  "",
        hikiateStatus:  "",
        hikiateStatusDescription:  "",
        effectiveInDate:  "",
        effectiveOutDate:  "",
        dataLoadTS:  "",
        option: data
      }
    }
      this.SpinnerService.show();
      this.hikiateStatusService.getHikiateStatusGrid(gridData).subscribe(data => {
        console.log(data)
        this.showdata = true;
        console.log(this.showdata);
        this.SpinnerService.hide();
        let datarow = data.payload;
        this.recordcount = data.pagination.totalRecords;
        this.rows = datarow.map(row => ({
          namc_cd: row['namc_cd'],
          fam_cd: row['fam_cd'],
          hikiate_stat_cd: row['hikiate_stat_cd'],
          hikiate_stat_desc: row['hikiate_stat_desc'],
          eff_dt: (row['eff_dt'] == null) ? '' : row['eff_dt'].split('T')[0],
          expr_dt: (row['expr_dt'] == null) ? '' : row['expr_dt'].split('T')[0],
          data_load_ts: (row['data_load_ts'] == null) ? '' : row['data_load_ts'].replace('Z', '').replace('T', ' ')
          // (row['data_load_ts'] == null) ? '' : row['data_load_ts'].split('T')[0],
        }));
        console.log(this.rows)
      }, err => {
        console.log(err);
        this.showdata = false;
        this.successMessage = "";
        console.log(this.showdata);
        this.rows = [];
        if (err == 0) {
          this.errorMessage = "Request timed out. Please try again.";
          this.SpinnerService.hide();
          this.globalrole.goToTop();
        } else {
          this.errorMessage = "No Records";
          this.SpinnerService.hide();
          this.globalrole.goToTop();
        }
      });
    } else {
      this.SpinnerService.hide();
      this.showdata = false;
      console.log(this.showdata);
      this.rows = [];
      this.errorMessage = "User does not have permission to perform 'read' operation";
      this.globalrole.goToTop();
    }

  }

  clearDate(event, name) {
    event.stopPropagation();
    if (name == 'effectiveInDate') {
      this.effectiveInDate = "";
    } else if (name == 'effectiveOutDate') {
      this.effectiveOutDate = "";
    }
  }

  userroleAccessfn() {
    return new Promise(resolve => {
      this.globalrole.Roledetails.subscribe(res => {
        console.log(res)
        this.Roledata = res;
      })
      console.log(this.Roledata);
      if (this.Roledata.length != 0) {
        this.Roledata.filter((res) => {
          if (res.function_nm == 'NBPC_9996') {
            this.roleAccess.push(res.access_desc);
          }
        })
        this.accessEnable = true;
        resolve(true)
      } else if (this.Roledata.length == 0) {
        let arrayvalue: any; let roleList: any;
        let data = localStorage.getItem('role');
        arrayvalue = data.split(',')
        console.log(arrayvalue.length, arrayvalue);
        let str = '';
        for (let i = 0; i < arrayvalue.length; i++) {
          if (str == '') {
            str = "'" + arrayvalue[i] + "'"
          } else {
            str += ',' + "'" + arrayvalue[i] + "'";
          }
          roleList = str;
        }
        let body = {
          security_grp_nm: roleList
        }
        let userpreviliagedata=localStorage.getItem('userpreviliagedata')

        if (userpreviliagedata && userpreviliagedata.length!=0 && userpreviliagedata!="") {
        this.globalrole.changeMessage(JSON.parse(userpreviliagedata))
            this.userroleAccessfn();
            this.accessEnable = true;
            resolve(true)
          }
        else {
          console.log(this.roleAccess)
          this.roleAccess = []
          this.errorMessage = "User does not have permission to perform 'read' operation";
          this.accessEnable = false;
          this.SpinnerService.hide();
        }
      }
      console.log(this.roleAccess);
    })
  }

 
}
